import { useTranslation } from 'react-i18next';
const OverlayPediatric = () => {
    const {t} = useTranslation();
    return (
        <div>
            <div className="overlayText">
                {t('pediatricDentistryText1')}
            </div>
            <div className="overlayText">
                {t('pediatricDentistryText2')}
            </div>
        </div>
    )
}

export default OverlayPediatric;